var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { useRetrievePlayerByUserId, useRetrieveTeamsByPlayerId, } from "./ApiProvider";
import Landing from "./Landing";
import { useRetrieveLeaguesByPlayerId } from "./api/LeagueApiProvider";
import { UserContext } from "./auth/UserProvider";
import { ErrorView } from "./nav/Error";
import { Loading } from "./nav/Loading";
import { HomeHub } from "./onboarding/HomeHub";
import { ProfileSetup } from "./onboarding/ProfileSetup";
import { dismissOnboarding, isOnboardingDismissed, } from "./onboarding/onboardingDismissal";
import { playerDisplayName } from "./players/PlayerDisplayNameLink";
import { PlayerPage } from "./players/PlayerPage";
var Home = function () {
    var _a = useContext(UserContext), contextUser = _a.user, isContextUserLoading = _a.loading;
    var _b = useRetrievePlayerByUserId({ userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk }), isPlayerLoading = _b.isLoading, playerError = _b.error, player = _b.data;
    var _c = useRetrieveTeamsByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _d = _c.data, teams = _d === void 0 ? [] : _d, isTeamsLoading = _c.isLoading;
    var _e = useRetrieveLeaguesByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _f = _e.data, leagues = _f === void 0 ? [] : _f, isLeaguesLoading = _e.isLoading;
    var _g = __read(useState(false), 2), dismissed = _g[0], setDismissed = _g[1];
    var _h = __read(useState(false), 2), hubDismissed = _h[0], setHubDismissed = _h[1];
    var loading = isPlayerLoading ||
        isContextUserLoading ||
        isTeamsLoading ||
        isLeaguesLoading;
    if (!contextUser && !isContextUserLoading) {
        return _jsx(Landing, {});
    }
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!player || playerError) {
        return _jsx(ErrorView, { error: new Error("Player not found") });
    }
    var isNewUser = teams.length === 0 && leagues.length === 0;
    var userPk = contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk;
    var profileSetupSeen = dismissed || (userPk !== undefined && isOnboardingDismissed(userPk));
    // First run: a brand-new user (no teams, no leagues) who hasn't been through
    // profile setup sees the standard player form behind a welcome. Save/Skip both
    // mark it seen and fall through to the Home hub.
    if (isNewUser && userPk !== undefined && !profileSetupSeen) {
        return (_jsx(ProfileSetup, { player: player, onDone: function () {
                dismissOnboarding(userPk);
                setDismissed(true);
            } }));
    }
    // Still nothing to show a feed for: offer the three first-run paths, unless
    // the user skipped the hub to look around (they can re-open it from the feed).
    if (isNewUser && !hubDismissed) {
        return (_jsx(HomeHub, { firstName: playerDisplayName(player).split(" ")[0], onSkip: function () { return setHubDismissed(true); } }));
    }
    return (_jsx(PlayerPage, { player: player, canViewTeams: true, canModify: true, onGetStarted: isNewUser ? function () { return setHubDismissed(false); } : undefined }));
};
export default Home;
